export function findDataArticle(
  data: {
    articles: number[];
    [key: string]: any; // Permet d'ajouter d'autres champs avec des noms et types variés
  }[],
  articleId: number,
): any | null {
  let findData = null;
  findData = data.filter(element => {
    return element.articles.includes(articleId);
  });
  return findData;
}
